<script lang="ts">
	// shadcn-svelte Dialog.Title (bits-ui), RESTYLED. Required by bits-ui for a11y
	// (labels the dialog). NO arbitrary `[..]` values.
	import { Dialog as DialogPrimitive } from "bits-ui";
	import { cn } from "../../../utils.js";

	let {
		ref = $bindable(null),
		class: className,
		...restProps
	}: DialogPrimitive.TitleProps = $props();
</script>

<DialogPrimitive.Title
	bind:ref
	data-slot="dialog-title"
	class={cn("text-base font-semibold leading-tight text-ink", className)}
	{...restProps}
/>
